<template>
  <div class="main" v-loading="isLoading">
     <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="modelMenu" current="谍报"  />
      <xy-toolbox-menu class="r"  >
          <xy-toolbox-menu-item icon="excel" @click="exportExcel">导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
   
    <div style="margin-top:20px;">
      <xy-toolbox-menu>
        <xy-toolbox-menu-item custom style="width:80%;">
          <div class="custom-content">
            <div style="margin-bottom:10px;">
              <el-select
                v-model="brands"
                placeholder="请选择品牌"
                filterable
                allow-create      
                default-first-option
                multiple
                remote
                @focus="onFocusFunc('1002')"
                :remote-method="getSearchCandidatesFunc"
                style="margin-right:5px;"
              >
                <template v-if="options['1002']">
                  <el-option
                    v-for="(item,index) in options['1002']"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </template>
              </el-select>

              <el-select
                v-model="models"
                placeholder="请选择子车型"
                filterable
                allow-create
                default-first-option
                multiple
                remote
                @focus="onFocusFunc('1003')"
                :remote-method="getSearchCandidatesFunc"
                style="margin-right:5px;"
              >
                <template v-if="options['1003']">
                  <el-option
                    v-for="(item,index) in options['1003']"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </template>
              </el-select>

              <el-select
                v-model="ggm"
                placeholder="请选工改模"
                filterable
                allow-create
                default-first-option
                multiple
                style="margin-right:5px;"
              >
                <el-option
                  v-for="(item,index) in ['GP','MCE1','MCE2-1','MCE2-2','MCE3','NM','MSRP','MCE2']"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-date-picker v-model="value2" type="year" style="width:150px; " placeholder="选择年"></el-date-picker>
              <el-button style="margin-left:20px;" @click="getReport">生成报告</el-button>
            </div>
          </div>
        </xy-toolbox-menu-item>
     
     
      </xy-toolbox-menu>
    </div>

    <div style="margin:auto 20px;">
      <el-collapse v-model="activeNames"  >
        <el-collapse-item title="图表" name="act1"  >
          <div id="chart"></div>
        </el-collapse-item>
        <el-collapse-item title="数据" name="act2">
          <el-table
            border
            fit
            :data="spyReportList"
            stripe
            tooltip-effect="dark"
            height="700"
            style="width:99.9%;white-space:nowrap;"
          >
            <el-table-column
              :label="item"
              :prop="item"
              v-for="(item, index) in columns"
              :key="index"
            ></el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<style scoped>
#chart {
  width: 100%;
  height: 600px;
  margin: 0 auto;
}
</style>
<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import ApiUrl from "../../store/apiurl";
import Permissions from  '../../store/permissions.js'
import echarts from "echarts";
export default {
  name: "espionage",
  data() {
    return {
      loading: false,
      value2: "",
      keyword: "",
      options: {},
      currentSmartSelectId: "All",
      activeNames: [""],
      columns: [],
      brands: [],
      models: [],
      ggm: [],
      chart: null,
      chartInit: false
    };
  },
  methods: {
    ...mapMutations("reports", ["setSpyReportList"]),
    ...mapActions("reports", ["loadSpyReport"]),
    getReport() {
        if(this.value2=="")
        {
          this.$message({
            message: "需要选择日期",
            duration: 2000
          });
            return ;
        }
      var year = this.value2.getFullYear();
      const post = {
        year: year,
        key: this.keyword
      };
      this.loadSpyReport({ postData: post, handle: this.bindData });
    },
    bindData(res) {
      if (!res) return;

      if (!this.chartInit) {
        this.chartInit = true;
        this.initChart();
      }
      
      
       var xAxisData = this.spyReportList.map(x=>x['子车型']);
       var  serviceData  = this.spyReportList.map(x=>1);
      var option ={
          xAxis:{
              data:xAxisData,
          },
        series: [
          {
              data:serviceData,
          }]
      };
      this.chart.setOption(option);
    },
    onFocusFunc(opt) {
      this.currentSmartSelectId = opt;
    },
    async getSearchCandidatesFunc(query) {
      try {
        const resp = await this.$axios.post(
          ApiUrl.salesanalysis.getsmartsearchkeyword,
          { id: this.currentSmartSelectId, keyword: query }
        );
        console.log(resp);
        this.timeout && clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          //  console.log(resp.data.result);
          //   cb(resp.data.result);
          var keys = [];
          for (var v in resp.data.result) {
            keys.push(resp.data.result[v].value);
          }
          //  this.options[this.currentSmartSelectId] = keys;
          // alert(JSON.stringify(this.options));
          this.$set(this.options, this.currentSmartSelectId, keys);
          // return (keyword) => { }
          this.timeout = null;
        }, 200);
      } catch (e) {
        console.log(e);
      }
    },
    initChart() {
      var myChart = echarts.init(document.getElementById("chart"));
      this.chart = myChart;
      var option = {
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "数量",
            type: "bar",
            barWidth: "60%",
            data: []
          }
        ]
      };

      myChart.setOption(option);
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    exportExcel() {
         if(!Permissions.Client_ViewNewCar_Report_Down  ())
            {
               this.$message({ message: "没有下载权限。", duration: 2000 });
               return ;
            }
      JSONToExcel(this.spyReportList, "谍报", "谍报");
    }
  },
  computed: {
    ...mapGetters("reports", {
      spyReportList: "spyReportList"
    }),
    ...mapState({
      isLoading: state => state.loadingCount > 0
    })
  },
  watch: {
    spyReportList(newValue) {
      this.columns.length = 0;
      for (var x in newValue[0]) {
        this.columns.push(x);
      }
    }
  }
};
</script>
<style .scoped>
.main .el-date-editor .el-range__icon {
  font-size: 14px;
  margin-left: 5px;
  color: #c0c4cc;
  float: left;
  line-height: 32px;
}
.el-collapse-item__header { padding-left:10px !important}
</style>